/* ----------------------------------------------------------------------------
 * ADICIONOU PELO "ADICIONAR RAPIDO" -> ABRE O CARRINHO
 * ----------------------------------------------------------------------------
 *
 * Por padrao o tema faz o contrario. Em theme.js, QuickBuyDrawer._onVariantAdded
 * marca `event.detail.blockCartDrawerOpening = true` e troca o conteudo da
 * gaveta por uma tela de confirmacao ("Adicionado ao carrinho!" + resumo +
 * Finalizar Compra / Checkout). O CartDrawer._onVariantAdded le essa marca e
 * volta sem abrir.
 *
 * Isso poe um passo a mais entre escolher e ver o carrinho, e e justamente o
 * passo que nao decide nada: a pessoa ja apertou "adicionar".
 *
 * Aqui a gente deixa o tema fazer o que faz e, logo depois, esconde a gaveta e
 * abre o carrinho. Nao mexe no theme.js (arquivo empacotado, some no proximo
 * update do tema) e nao depende da ordem em que os listeners foram registrados.
 *
 * FALHA ABERTO: se o carrinho nao for do tipo "gaveta", ou se o <cart-drawer>
 * nao existir na pagina, o script nao faz nada e o comportamento volta a ser o
 * de fabrica. Nunca deixa a pessoa sem saida depois de adicionar.
 *
 * ⚠️ O conteudo do carrinho e atualizado por um evento separado, "cart:change",
 * que o mesmo formulario dispara logo apos o "variant:add". Abrir aqui e a
 * mesma ordem que o tema usa numa PDP comum, onde o carrinho ja abre sozinho.
 * -------------------------------------------------------------------------- */

(function () {
  'use strict';

  /* 🔴 CAPTURA, nao bolha, e este foi o bug da primeira versao.
   *
   * A ordem do evento "variant:add" e: formulario -> <quick-buy-drawer> ->
   * document. O listener do tema, no elemento da gaveta, faz replaceChildren
   * pra trocar o conteudo pela tela de confirmacao, e isso DESLIGA o formulario
   * do DOM. Quando o meu listener rodava no document, ev.target ja estava solto
   * e `closest('quick-buy-drawer')` devolvia null: o script nunca reconhecia a
   * gaveta e a tela de confirmacao continuava aparecendo.
   *
   * Na fase de captura o meu roda ANTES do listener da gaveta, com o formulario
   * ainda no lugar. Guardo a referencia agora e ajo depois. */
  document.addEventListener('variant:add', function (ev) {
    var alvo = ev.target;
    if (!alvo || !alvo.closest) return;

    var gaveta = alvo.closest('quick-buy-drawer');
    if (!gaveta) return;   /* veio de uma PDP normal: o tema ja abre o carrinho */

    var tipo = window.themeVariables &&
               window.themeVariables.settings &&
               window.themeVariables.settings.cartType;
    if (tipo !== 'drawer') return;

    var carrinho = document.querySelector('cart-drawer');
    if (!carrinho || typeof carrinho.show !== 'function') return;

    /* deixa o listener do proprio tema terminar antes de trocar as gavetas */
    requestAnimationFrame(function () {
      try { gaveta.hide(); } catch (e) {}
      try { carrinho.show(); } catch (e) {}
    });
  }, true);
})();
